module.exports = __webpack_public_path__ + "assets/certificate_pdf/Barista_Silicon Stone Education_20141029.50853acf.pdf";